<div class="dialog-container">
  <h2 class="card-header header-background">Please Enter PreBuild Tier Name</h2>
  <mat-form-field>
    <input matInput placeholder="PreBuild Tier Name" [(ngModel)]="preBuildTierName">
  </mat-form-field>
  <div class="buttons">
    <button mat-button (click)="save()" class="mat-focus-indicator mat-button mat-button-base">Save</button>
    <button mat-button (click)="cancel()" class="mat-focus-indicator mat-button mat-button-base">Cancel</button>
  </div>
</div>